export default {
  clinicManagement: () => import('./clinicManagement/index.vue'), // 诊所管理
  newClinic: () => import('./newClinic/index.vue'), // 新增诊所
  userManagement: () => import('./userManagement/index.vue'), // 用户管理
  newUser: () => import('./newUser/index.vue'), // 新增用户
  information: () => import('./information/index.vue'), // 资讯管理
  newInformation: () => import('./newInformation/index.vue'), // 新增资讯
  platformAudit: () => import('./platformAudit/index.vue'), // 平台审核
  drugAudit: () => import('./drugAudit/index.vue'), // 药品审核
  applyRegisterList: () => import('./applyRegisterList/index.vue'), // 申请注册列表
};
